// extracted by mini-css-extract-plugin
module.exports = {"document":"DownloadFileList-module--document--2weEC","download":"DownloadFileList-module--download--3-YOg","documentName":"DownloadFileList-module--documentName--3Z2mf"};